<template>
    <div class="ForgotPassword2">
        <div class="pass2" >
            <div class="proba1 container d-flex flex-column ">
             <img class="align-self-start" src="../assets/img/NAVIGATION.svg" alt="">
                <div class="proba2 d-flex flex-column justify-content-center align-items-center">
                <img  src="../assets/img/pismo.png" alt="">
                <h1 class="text-center">New Password Is Sent to You</h1>
                <p class="text-center">Please do check it, and continiue with using our service</p>
                <button class="btn btn-primary my-rounded pl-5 pr-5">SING IN</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ForgotPassword2',
  
}

</script>

<style scoped>

@import '../style.css';

.my-rounded{
    border-radius: 50px;
}

.btn-primary {
    color: #fff;
    background-color: #29E4B7;
    border-color: #29E4B7;
}

.form-control{
    width: 50%;
    color: #29E4B7!important;   
}

.form-control:focus{
    color: #29E4B7!important;
}
::placeholder{
    color: #29E4B7!important;
}

.pl-5{
    padding-left: 5rem!important;
}
.pr-5{
    padding-right: 5rem!important;
}

/* drugi korak */
.pass2{
    width: 100%;
    height: 100vh;
    background-color:#202646;
    color: white;
}

.proba2{
    height: 80vh;
}



</style>